import axios from 'axios';

const removeAuthToken = (): void => {
  delete axios.defaults.headers.common['Authorization'];
};

export default removeAuthToken;
